import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Auto-load all *_controller.js files:
const controllerFiles = import.meta.glob("./**/*_controller.js", { eager: true });

Object.entries(controllerFiles).forEach(([path, controller]) => {
  const name = path
    .replace("./", "")
    .replace("_controller.js", "")
    .replace(/\//g, "--");

  application.register(name, controller.default);
});
